import React, { useState , useEffect} from 'react';
import Form from "react-bootstrap/Form";
import {Button} from "react-bootstrap";

function TradeSidePicker(props) {

    useEffect(() => {
        console.log("tradeSide: " + props.tradeSide);
    }, []);

    return (
        <Form.Group className="mb-3">
            <Form.Label>Trade Side</Form.Label>
            <div className="d-flex justify-content-between">
                <Button
                    variant={props.tradeSide === "LONG" ? "success" : "outline-success"}
                    active={props.tradeSide === "LONG"}
                    onClick={() => props.setTradeSide("LONG")}
                    className="w-100">
                    LONG
                </Button>
                <Button
                    variant={props.tradeSide === "SHORT" ? "danger" : "outline-danger"}
                    active={props.tradeSide === "SHORT"}
                    onClick={() => props.setTradeSide("SHORT")}
                    className="w-100 ms-1">
                    SHORT
                </Button>
            </div>
        </Form.Group>
    );
}

export default TradeSidePicker;